<template>
    <section class="init_box" style="background-color:white">
        <el-row style="padding-top:10px">
            <el-col :span="3">
                <div>
                    <el-button size="small" v-if="btnRole.indexOf('138') != -1" type="primary" class="btn"
                        @click="insertProject = true">添加项目</el-button>
                    <el-button size="small" type="primary" class="btn" @click="export2Excel">导出台账</el-button>
                </div>
            </el-col>
            <el-col :span="21">
                <el-form :inline="true" ref="form" :model="formInline" label-width="80px" class="demo-form-inline">
                    <el-form-item label="项目">
                        <el-select v-model="formInline.project" filterable clearable placeholder="请选择项目">
                            <el-option v-for="item in projects" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="试验室">
                        <el-select v-model="formInline.company" filterable clearable placeholder="请选择试验室">
                            <el-option v-for="item in laboratoryData" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="项目类型">
                        <el-select v-model="formInline.projectType" filterable clearable placeholder="请选择项目类型">
                            <el-option v-for="item in projectType" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="日期">
                        <el-date-picker v-model="formInline.date" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-input v-model="formInline.neirong" auto-complete="off" placeholder="请输入搜索内容"></el-input>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button size="small" type="primary" @click="getprojectinfo">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table :data="projectTableData" :header-cell-style="{ background: '#eff3f6' }" stripe
                    style="width: 100%;text-align: center;">
                    <el-table-column type="index" label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectName" label="项目名称" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="companyId" :width="450" label="试验室" show-overflow-tooltip
                        :formatter="formateLaboratory">
                    </el-table-column>
                    <el-table-column prop="startTime" label="开始日期" show-overflow-tooltip :formatter="formateStartTime">

                    </el-table-column>
                    <el-table-column prop="endTime" label="结束日期" show-overflow-tooltip :formatter="formateEndTime">

                    </el-table-column>
                    <el-table-column prop="postion" label="项目地址" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="projectType" label="项目类型" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.projectType == 1">桥梁</span>
                            <span v-if="scope.row.projectType == 2">隧道</span>
                            <span v-if="scope.row.projectType == 3">水利</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column label="操作" width="150" style="text-decoration: none;">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="clickDelete(scope.row)">
                                删除
                            </el-button>
                            <el-button type="text" size="small" @click="clickUpdate(scope.row)">
                                修改
                            </el-button>
                            <el-button type="text" v-if="btnRole.indexOf('139') != -1" size="small"
                                @click="clickMenu(scope.row)">
                                <!-- <router-link to="/projectinfo_device" style="text-decoration: none;color: #4095E5;"> -->
                                查看设备
                                <!-- </router-link> -->
                            </el-button>

                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <!--分页工具条-->
            <el-col :span="24" class="toolbar" style="margin-top:15px">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
                    :total="total" style="float:right">
                </el-pagination>
            </el-col>
        </el-row>
        <el-dialog title="添加项目" :close-on-click-modal="false"
      :close-on-press-escape="false" :visible.sync="insertProject" width="30%" @close="clickclose">
            <el-form :model="insertForm" ref="insertForm" label-position="left" label-width="auto"
                style="width: 90%; margin-left: 5%">
                <el-form-item label="项目名称" prop="projectName" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-input class="formInput" placeholder="请输入项目名称" size="small" style="width: 100%" v-model="insertForm.projectName" />
                </el-form-item>
                <el-form-item label="试验室" prop="companyId" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-select  class="formInput" multiple  size="small" v-model="insertForm.companyId" filterable clearable placeholder="请选择试验室">
                        <el-option v-for="item in laboratoryData" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="项目类型" prop="projectType" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-select  class="formInput" size="small" v-model="insertForm.projectType" filterable clearable placeholder="请选择项目类型">
                        <el-option  v-for="item in projectType" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="项目位置" prop="postion" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-input  class="formInput" size="small" placeholder="请输入项目位置" style="width: 100%" v-model="insertForm.postion" />
                </el-form-item>
                <el-form-item label="开始时间" prop="startTime" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-date-picker  class="formInput" size="small" v-model="insertForm.startTime" type="date" placeholder="请选择开始时间" 
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker  class="formInput" size="small" v-model="insertForm.endTime" type="date" placeholder="请选择结束时间" 
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input  class="formInput" size="small" placeholder="请输入备注" style="width: 100%" v-model="insertForm.remark" />
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button style="margin-left: 10px" size="small" type="primary" @click="clickComit">提交</el-button>
                <el-button @click="clickclose" size="small">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改项目" :close-on-click-modal="false"
      :close-on-press-escape="false" :visible.sync="updateProject" width="30%" @close="clickUpdateClose">
            <el-form :model="updateForm" ref="updateForm" label-position="left" label-width="auto"
                style="width: 90%; margin-left: 5%">
                <el-input class="formInput" v-show="false" style="width: 100%" v-model="updateForm.id" />
                <el-form-item label="项目名称" prop="projectName" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-input class="formInput" placeholder="请输入项目名称" size="small" style="width: 100%" v-model="updateForm.projectName" />
                </el-form-item>
                <el-form-item label="试验室" prop="companyId" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-select  class="formInput" multiple  size="small" v-model="updateForm.companyId" filterable clearable placeholder="请选择试验室">
                        <el-option v-for="item in laboratoryData" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="项目类型" prop="projectType" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-select  class="formInput" size="small" v-model="updateForm.projectType" filterable clearable placeholder="请选择项目类型">
                        <el-option  v-for="item in projectType" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="项目位置" prop="postion" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-input  class="formInput" size="small" placeholder="请输入项目位置" style="width: 100%" v-model="updateForm.postion" />
                </el-form-item>
                <el-form-item label="开始时间" prop="startTime" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-date-picker  class="formInput" size="small" v-model="updateForm.startTime" type="date" placeholder="请选择开始时间" 
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker  class="formInput" size="small" v-model="updateForm.endTime" type="date" placeholder="请选择结束时间" 
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input  class="formInput" size="small" placeholder="请输入备注" style="width: 100%" v-model="updateForm.remark" />
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button style="margin-left: 10px" size="small" type="primary" @click="clickSave">保存</el-button>
                <el-button @click="clickUpdateClose" size="small">取消</el-button>
            </div>
        </el-dialog>
    </section>
</template>
<script>
import { method } from 'lodash';
import { selectAllProjectinfo, updateProjectinfo, insertProjectinfo, deleteProjectinfo, selectAllProjectName, getSys } from '../../api/api';

export default {
    data() {
        return {
            total: 0,
            pageIndex: 1,
            pagesize: 10,
            projects: [],
            projectType: [{
                label: "桥梁",
                value: 1
            }, {
                label: "隧道",
                value: 2
            }, {
                label: "水利",
                value: 3
            }],
            formInline: {
                project: '',
                company: '',
                department: '',
                date: '',
                neirong: '',
                projectType: ''
            },
            insertForm: {
                projectName: "",
                companyId:"",
                projectType:"",
                remark:"",
                startTime:"",
                postion:"",
                endTime:"",
            },
            updateForm: {
                id:"",
                projectName: "",
                companyId:"",
                projectType:"",
                remark:"",
                startTime:"",
                postion:"",
                endTime:"",
            },
            tableData: [],
            projectTableData:[],
            btnRole: [],
            laboratoryData: [],
            insertProject: false,
            updateProject:false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            },
        }

    },
    methods: {
        handleCurrentChange(val) {
            this.pageIndex = val;
            // this.getDataList();
            this.projectTableData = this.tableData.slice(
                (this.pageIndex - 1) * this.pagesize,
                this.pageIndex * this.pagesize
            );
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pagesize = val;
            this.projectTableData = this.tableData.slice(
                (this.pageIndex - 1) * this.pagesize,
                this.pageIndex * this.pagesize
            );
        },
        // 获取项目名称
        getProjectName() {
            selectAllProjectName().then(datas => {
                let { data, message, status } = datas
                if (status == 200) {
                    for (var i = 0; i < data.length; i++) {
                        this.projects.push({ label: data[i].projectName, value: data[i].projectName })
                    }
                }
            })
        },
        // 获取试验室
        getLaboratory() {
            getSys().then(datas => {
                let { data, message, status } = datas
                if (status == 200) {
                    for (var i = 0; i < data.length; i++) {
                        this.laboratoryData.push({ label: data[i].companyName, value: data[i].companyCode })
                    }
                }
            })
        },
        //点击把菜单的名字传出去
        clickMenu(vals) {
            debugger
            //保存数据
            sessionStorage.setItem('projectName', vals.projectName)
            sessionStorage.setItem('company', vals.companyId)
            //添加路由跳转至查看设备
            this.$router.push({
                path: "projectinfo_device",

            });
        },
        // 点击删除
        clickDelete(vals) {
            debugger
            this.$confirm("确定删除" + vals.projectName + "吗？", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let _params = {
                    id: vals.id,
                    userid: JSON.parse(localStorage.getItem("user")).userId
                }
                deleteProjectinfo(_params).then(datas => {
                    let { status, message, data } = datas
                    if (status == 200) {
                        this.$message({ message: message, type: 'success' });
                        this.getprojectinfo();
                    }
                })
            })
        },
        // 点击修改
        clickUpdate(vals) {
            // this.updateForm.companyId=""
            let companyid=vals.companyId.split(",")
            
            this.updateProject=true
            this.updateForm.id=vals.id
            this.updateForm.projectName=vals.projectName
            this.updateForm.projectType=vals.projectType
            this.updateForm.postion=vals.postion
            this.updateForm.startTime=vals.startTime
            this.updateForm.endTime=vals.endTime
            this.updateForm.remark=vals.remark
            this.updateForm.companyId=companyid
        },
        // 点击保存
        clickSave(){
            let _parmas={
                projectinfos:JSON.stringify(this.updateForm),
                userid:JSON.parse(localStorage.getItem("user")).userId
            }
            updateProjectinfo(_parmas).then(datas=>{
                let {data,message,status}=datas
                if(status==200){
                    this.$message({ message: message, type: 'success' });
                    this.clickUpdateClose()
                    this.getprojectinfo();
                }
            })
        },
        // 获取项目信息
        getprojectinfo() {
            let startTime = ""
            let endTime = ""
            if (this.formInline.date.length > 0) {
                startTime = (this.formInline.date[0]).getFullYear() + "-" + ((this.formInline.date[0]).getMonth() + 1).toString().padStart(2, '0') + "-" + (this.formInline.date[0]).getDate().toString().padStart(2, '0')
                endTime = (this.formInline.date[1]).getFullYear() + "-" + ((this.formInline.date[1]).getMonth() + 1).toString().padStart(2, '0') + (this.formInline.date[1]).getDate().toString().padStart(2, '0')
            }
            let _params = {
                projectName: this.formInline.project,
                startTime: startTime,
                endTime: endTime,
                projectType: this.formInline.projectType,
                companyCode: this.formInline.company
            }

            selectAllProjectinfo(_params).then(datas => {
                let { data, message, status } = datas
                if (status == 200) {
                    this.total=data.length
                    this.projectTableData=data.slice(0,this.pagesize)
                    this.tableData = data;
                }
            })
        },
        export2Excel() {
            require.ensure([], () => {
                const { export_json_to_excel } = require('../../excel/Export2Excel');// 这里 require 写你的Export2Excel.js的绝对地址
                const tHeader = ['项目名称', '实验室', '开始日期', '结束日期', '项目地址', '项目类型']; //对应表格输出的title
                // for(var i=0;i<this.deviceTable.length;i++){
                //     tHeader.push(this.deviceTable[i].label)
                // }
                const filterVal = ['projectName', 'department', 'startDate', 'endDate', 'address', 'projectType']; // 对应表格输出的数据
                // for(var i=0;i<this.deviceTable.length;i++){
                //     filterVal.push(this.deviceTable[i].prop)
                // }
                const list = this.tableData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, '项目信息'); //对应下载文件的名字
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },
        clickclose(){
            this.insertProject=false;
            this.$refs['insertForm'].resetFields()
            // Object.keys(insertForm).forEach((key) => (insertForm[key] = ''))
        },
        clickUpdateClose(){
            this.updateProject=false;
            this.$refs['updateForm'].resetFields()
        },
        // 点击提交按钮
        clickComit(){
            let _params={
                projectinfos:JSON.stringify(this.insertForm),
                userid:JSON.parse(localStorage.getItem("user")).userId
            }
            insertProjectinfo(_params).then(datas=>{
                let {data,status,message} = datas
                if(status==200){
                    this.$message({ message: message, type: 'success' });
                    this.clickclose();
                    this.getprojectinfo();
                }
            })
        },
        showBtn() {
            let userinfo = JSON.parse(localStorage.getItem("user"))
            
            this.btnRole = userinfo.role.menuId.split(",")
        },
        // 格式化试验室
        formateLaboratory(row) {
            let companyid = row.companyId
            let companyName = ""
            if (companyid != null && companyid.length > 0) {
                let companyids = companyid.split(",")
                for (var i = 0; i < this.laboratoryData.length; i++) {
                    for (var j = 0; j < companyids.length; j++) {
                        if (this.laboratoryData[i].value == companyids[j]) {
                            if (j == 0) {
                                companyName += this.laboratoryData[i].label
                            } else {
                                companyName += "," + this.laboratoryData[i].label
                            }
                        }
                    }
                }

            }
            return companyName
        },
        // 格式化开始时间显示到日期
        formateStartTime(row) {
            if(row.startTime!=undefined){
                if (row.startTime != null || row.startTime.length > 0) {
                    let nowData = new Date(row.startTime)
                    let year = nowData.getFullYear();
                    let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
                    let date = nowData.getDate().toString().padStart(2, '0');
                    return `${year}-${month}-${date}`;
                }
            }else{
                return ""
            }
        },
        // 格式化结束时间显示到日期
        formateEndTime(row) {
            if(row.endTime!=undefined){
                if (row.endTime != null || row.endTime.length > 0) {
                    let nowData = new Date(row.endTime)
                    let year = nowData.getFullYear();
                    let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
                    let date = nowData.getDate().toString().padStart(2, '0');
                    return `${year}-${month}-${date}`;
                }
            }else{
                return ""
            }
        },
        
    },
    created() {
        this.getLaboratory()
        this.showBtn()
        this.getProjectName()
        this.getprojectinfo()
    }

}
</script>
<style scoped>
/* .el-button--small{
    width: 80%!important;
}
.el-button--small>span{
    text-align: left!important;;
} */
.el-input {
    width: 70% !important;
}
.formInput{
    width: 90%!important;
}

</style>
<style>
.el-form-item__error{
    left: 25px!important;
}
</style>


// WEBPACK FOOTER //
// src/views/device/Projectinfo.vue